import i18n from '@/utils/i18n';
const state = {
  // 房型option
  roomType: []
}
const mutations = {
  SET_ROOM_TYPE(state, arr) {
    state.roomType = arr
  }
}
export default {
  state,
  mutations
}
